module.exports = __webpack_public_path__ + "img/adventure_time.41e0fa89.jpg";